import React from "react";
import { useTranslation, Trans } from "react-i18next";
import {
  PatternlibContactItem,
  PatternlibListItem,
  PatternlibList,
  PatternlibTextlink,
} from "@liebherr/patternlib-react";
import styles from "./Imprint.module.css";
import MainNavigation from "../../components/main-navigation/MainNavigation";
import Separator from "../../components/separator/Separator";
import agbs from "../../pdf/Allgemeine_Liefer-_und_Zahlungsbedingungen.pdf";
import termsAndConditions from "../../pdf/General_Terms_and_Conditions_of_Delivery_and_Payment.pdf";
import PropTypes from "prop-types";

const Imprint = ({ profile, isDemoUser }) => {
  const { t, i18n } = useTranslation();

  const ListItem = ({ text, children }) => {
    return (
      <li>
        <span className={styles.icons}></span>
        <span>{text}</span>
        {children}
      </li>
    );
  };

  const showSetting = "javascript:usercentrics.showSettings();";

  ListItem.propTypes = {
    text: PropTypes.string,
    children: PropTypes.element,
  };

  ListItem.defaultProps = {
    text: "",
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.navigation}>
          <MainNavigation
            activeTab={null}
            profile={profile}
            isDemoUser={isDemoUser}
          ></MainNavigation>
        </div>
      </header>
      <div className={styles.body}>
        <h1>{t("imprint.title")}</h1>
        {/* Imprint */}
        <div className={styles.contentWrapper}>
          <h2>{t("imprint.imprint.title")}</h2>
          <PatternlibList>
            <PatternlibListItem>
              <span>{t("imprint.imprint.addressTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.address")}</span>
              </div>
            </PatternlibListItem>
            <PatternlibListItem>
              <span>{t("imprint.imprint.telTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.tel")}</span>
              </div>
            </PatternlibListItem>
            <PatternlibListItem>
              <span>{t("imprint.imprint.emailTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.email")}</span>
              </div>
            </PatternlibListItem>
            <PatternlibListItem>
              <span>{t("imprint.imprint.managementTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.management")}</span>
              </div>
            </PatternlibListItem>
            <PatternlibListItem>
              <span>{t("imprint.imprint.vatTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.vat")}</span>
              </div>
            </PatternlibListItem>
            <PatternlibListItem>
              <span>{t("imprint.imprint.companiesRegisterTitle")}</span>
              <div slot="value" className={styles.list}>
                <span>{t("imprint.imprint.companiesRegister")}</span>
              </div>
            </PatternlibListItem>
          </PatternlibList>
          <Separator space="xl"></Separator>
          <h2>{t("imprint.imprint.contactTitle")}</h2>
          <Separator space="xs"></Separator>
          <h3>{t("imprint.imprint.companyName")}</h3>
          <div className={styles.address}>
            <span>{t("imprint.imprint.contactAdress")}</span>
          </div>
          <div className={styles.contactItemsWrapper}>
            <PatternlibContactItem
              type="phone"
              value={t("imprint.imprint.tel")}
              icon="business-cell-phones"
            ></PatternlibContactItem>
            <PatternlibContactItem
              type="email"
              value={t("imprint.imprint.email")}
              icon="envelope"
            ></PatternlibContactItem>
          </div>
        </div>

        {/* Data protection */}
        <div className={styles.contentWrapper}>
          {/* Intro */}
          <h2>{t("imprint.dataProtection.title")}</h2>
          <h3>{t("imprint.dataProtection.subTitle")}</h3>
          <p className={styles.paragraph}>
            {t("imprint.dataProtection.intro")}
          </p>

          <Separator space="xxxxxs"></Separator>

          {/* ************************************************ */}
          {/* A.	Allgemeine Informationen */}
          {/* ************************************************ */}
          <h3>{t("imprint.dataProtection.generalInfo.title")}</h3>

          {/* I.	Was sind personenbezogene Daten und was bedeutet Verarbeitung? */}
          <h4>{t("imprint.dataProtection.generalInfo.first.title")}</h4>
          <ul className={styles.list}>
            <ListItem
              text={
                <Trans
                  i18nKey="imprint.dataProtection.generalInfo.first.dashOne"
                  components={{
                    strong: <strong />,
                  }}
                />
              }
            ></ListItem>
            <ListItem
              text={
                <Trans
                  i18nKey="imprint.dataProtection.generalInfo.first.dashTwo"
                  components={{
                    strong: <strong />,
                  }}
                />
              }
            ></ListItem>
          </ul>

          <Separator space="xxxxxs"></Separator>

          {/* II.	Wer ist der Verantwortliche für die Verarbeitung Ihrer Daten? */}
          <h4>{t("imprint.dataProtection.generalInfo.second.title")}</h4>
          <span>
            {t("imprint.dataProtection.generalInfo.second.describtion")}
          </span>
          <h4>{t("imprint.imprint.companyName")}</h4>
          <div className={styles.address}>
            <span>{t("imprint.imprint.contactAdress")}</span>
          </div>
          <div className={styles.contactItemsWrapper}>
            <PatternlibContactItem
              type="phone"
              value={t("imprint.imprint.tel")}
              icon="business-cell-phones"
            ></PatternlibContactItem>
            <PatternlibContactItem
              type="email"
              value={t("imprint.imprint.emailDataProtection")}
              icon="envelope"
            ></PatternlibContactItem>
          </div>

          <Separator space="s"></Separator>

          {/* III.	Wie können Sie unseren Datenschutzbeauftragten erreichen? */}
          <h4>{t("imprint.dataProtection.generalInfo.third.title")}</h4>
          <span>
            {t("imprint.dataProtection.generalInfo.third.describtion")}
          </span>
          <h4>{t("imprint.dataProtection.generalInfo.third.subTitle")}</h4>
          <div className={styles.address}>
            <span>{t("imprint.imprint.contactAdressDataProtection")}</span>
          </div>
          <div className={styles.contactItemsWrapper}>
            <PatternlibContactItem
              type="email"
              value={t("imprint.imprint.emailDataProtection2")}
              icon="envelope"
            ></PatternlibContactItem>
          </div>

          <Separator space="s"></Separator>

          {/* IV.	Welche Rechte haben Sie als betroffene Person? */}
          <h4>{t("imprint.dataProtection.generalInfo.fourth.title")}</h4>
          <span>
            {t(
              "imprint.dataProtection.generalInfo.fourth.sectionOne.describtion"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashThree"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashFour"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashFive"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashSix"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.generalInfo.fourth.sectionOne.dashSeven"
              )}
            ></ListItem>
          </ul>
          <p className={styles.paragraph}>
            {t(
              "imprint.dataProtection.generalInfo.fourth.sectionTwo.describtion"
            )}
          </p>

          <Separator space="xxxxxs"></Separator>

          {/* V. Links zu anderen Websites */}
          <h4>{t("imprint.dataProtection.generalInfo.fifth.title")}</h4>
          <span>
            {t("imprint.dataProtection.generalInfo.fifth.describtion")}
          </span>

          <Separator space="s"></Separator>

          {/* ************************************************ */}
          {/* B.	Datenverarbeitung */}
          {/* ************************************************ */}
          <h3>{t("imprint.dataProtection.dataProcessing.title")}</h3>

          {/* Logfiles */}
          <h4>{t("imprint.dataProtection.dataProcessing.first.title")}</h4>
          <span>
            {t("imprint.dataProtection.dataProcessing.first.describtion")}
          </span>
          <Separator space="xs"></Separator>
          <h4>
            {t("imprint.dataProtection.dataProcessing.first.sectionOne.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionOne.describtion"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashThree"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashFour"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashFive"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashSix"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashSeven"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.first.sectionOne.dashEight"
              )}
            ></ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionTwo.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionTwo.describtionTwo"
            )}
          </span>
          <Separator space="s"></Separator>
          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionThree.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionThree.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionThree.describtionTwo"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.first.sectionThree.describtionThree"
            )}
          </span>

          <Separator space="s"></Separator>

          {/* Authentifizierung/Autorisierung */}
          <h4>{t("imprint.dataProtection.dataProcessing.second.title")}</h4>
          <span>
            {t("imprint.dataProtection.dataProcessing.second.describtion")}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.second.sectionOne.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.second.sectionOne.describtionOne"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.second.sectionOne.dashOne"
                components={{
                  strong: <strong />,
                }}
              />
            </ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.second.sectionOne.describtionTwo"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.second.sectionOne.describtionThree"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.second.sectionTwo.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.second.sectionTwo.describtion"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>{t("imprint.dataProtection.dataProcessing.third.title")}</h4>
          <span>
            {t("imprint.dataProtection.dataProcessing.third.describtion")}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.third.sectionOne.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.third.sectionOne.describtion"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionOne.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionOne.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionOne.dashThree"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionOne.dashFive"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionOne.dashSix"
              )}
            ></ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.third.sectionTwo.describtionOne"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionTwo.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionTwo.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionTwo.dashThree"
              )}
            ></ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.third.sectionTwo.describtionTwo"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.third.sectionThree.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.third.sectionThree.describtion"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionThree.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.third.sectionThree.dashTwo"
              )}
            ></ListItem>
          </ul>

          <Separator space="s"></Separator>

          <h4>{t("imprint.dataProtection.dataProcessing.fourth.title")}</h4>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.fourth.sectionOne.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionOne.describtion"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.fourth.sectionTwo.title")}
          </h4>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionTwo.describtionOne"
              components={{
                strong: <strong />,
              }}
            />
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTwo.describtionTwo"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionTwo.dashOne"
                components={{
                  strong: <strong />,
                }}
              />
            </ListItem>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionTwo.dashTwo"
                components={{
                  strong: <strong />,
                }}
              />
            </ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTwo.describtionThree"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionThree.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionThree.describtionOne"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.dashOne"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                }}
              />
            </ListItem>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.dashTwo"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                }}
              />
            </ListItem>
          </ul>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionThree.describtionTwo"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.dashThree"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                }}
              />
            </ListItem>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.dashFour"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                }}
              />
            </ListItem>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.dashFive"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                }}
              />
            </ListItem>
          </ul>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionThree.describtionThree"
              components={{
                strong: <strong />,
              }}
            />
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFour.title"
            )}
          </h4>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFive.title"
            )}
          </h4>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFive.subtitle"
            )}
          </h4>

          <Separator space="s"></Separator>

          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.columnOne"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.columnTwo"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.columnThree"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.columnFour"
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowOne.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowOne.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowOne.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowOne.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowTwo.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowTwo.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowTwo.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowTwo.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowThree.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowThree.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowThree.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowThree.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowFour.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowFour.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowFour.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.table.rowFour.4"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <Separator space="s"></Separator>

          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionFive.dashOne"
                components={{
                  strong: <strong />,
                  a: <a href={showSetting}></a>,
                  br: <br />,
                }}
              />

              <Separator space="s"></Separator>

              <PatternlibList>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressTitle0ne"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <span>
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressOne"
                      )}
                    </span>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleOne"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkOne"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkOne"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleTwo"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTwo"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTwo"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleThree"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkThree"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkThree"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
              </PatternlibList>
            </ListItem>
          </ul>

          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionFive.dashTwo"
                components={{
                  strong: <strong />,
                  br: <br />,
                }}
              />
              <Separator space="s"></Separator>

              <PatternlibList>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressTitleTwo"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <span>
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressTwo"
                      )}
                    </span>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressTitleThree"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <span>
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.addressThree"
                      )}
                    </span>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleFour"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkFour"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkFour"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleFive"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkFive"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkFive"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkTitleSix"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkSix"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionFive.linkSix"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
              </PatternlibList>
            </ListItem>
          </ul>

          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionFive.dashThree"
                components={{
                  strong: <strong />,
                  br: <br />,
                }}
              />
            </ListItem>
          </ul>

          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionFive.dashFour"
                components={{
                  strong: <strong />,
                  br: <br />,
                }}
              />
            </ListItem>
          </ul>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.fourth.sectionSix.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSix.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSix.describtionTwo"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSix.describtionThree"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionSix.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionSix.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionSix.dashThree"
              )}
            ></ListItem>
          </ul>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSeven.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSeven.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSeven.describtionTwo"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionEight.title"
            )}
          </h4>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionEight.describtion"
              components={{
                strong: <strong />,
              }}
            />
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionNine.title"
            )}
          </h4>
          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.columnOne"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.columnTwo"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.columnThree"
                    )}
                  </th>
                  <th>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.columnFour"
                    )}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowOne.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowOne.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowOne.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowOne.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowTwo.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowTwo.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowTwo.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowTwo.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowThree.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowThree.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowThree.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowThree.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFour.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFour.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFour.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFour.4"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFive.1"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFive.2"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFive.3"
                    )}
                  </td>
                  <td>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.table.rowFive.4"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <ul className={styles.list}>
            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionNine.dashOne"
                components={{
                  strong: <strong />,
                  br: <br />,
                }}
              />
            </ListItem>

            <Separator space="s"></Separator>

            <ListItem>
              <Trans
                i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionNine.dashTwo"
                components={{
                  strong: <strong />,
                  br: <br />,
                  a: <a />,
                }}
              />

              <Separator space="s"></Separator>

              <PatternlibList>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.addressTitle"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <span>
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.address"
                      )}
                    </span>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTitleOne"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkOne"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkOne"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTitleTwo"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTwo"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTwo"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTitleThree"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkThree"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkThree"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTitleFour"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkFour"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkFour"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
                <PatternlibListItem>
                  <span>
                    {t(
                      "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkTitleFive"
                    )}
                  </span>
                  <div slot="value" className={styles.list}>
                    <a
                      href={t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkFive"
                      )}
                    >
                      {t(
                        "imprint.dataProtection.dataProcessing.fourth.sectionNine.linkFive"
                      )}
                    </a>
                  </div>
                </PatternlibListItem>
              </PatternlibList>
            </ListItem>
          </ul>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionNine.describtion"
              components={{
                strong: <strong />,
                a: (
                  <a
                    href={
                      i18n.language === "de-DE" || i18n.language === "de"
                        ? "https://tools.google.com/dlpage/gaoptout?hl=de"
                        : "https://tools.google.com/dlpage/gaoptout?hl=en"
                    }
                  ></a>
                ),
              }}
            />
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t("imprint.dataProtection.dataProcessing.fourth.sectionTen.title")}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTen.describtion"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionEleven.title"
            )}
          </h4>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionEleven.describtionOne"
              components={{
                a: <a href={showSetting}></a>,
              }}
            />
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionEleven.describtionTwo"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionEleven.describtionThree"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionEleven.describtionFour"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTwelve.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTwelve.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionTwelve.describtionTwo"
            )}
          </span>
          <span>
            <Trans
              i18nKey="imprint.dataProtection.dataProcessing.fourth.sectionTwelve.describtionThree"
              components={{
                a: <a href={showSetting}></a>,
              }}
            />
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.describtion"
            )}
          </span>
          <ul className={styles.list}>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.dashOne"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.dashTwo"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.dashThree"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.dashFour"
              )}
            ></ListItem>
            <ListItem
              text={t(
                "imprint.dataProtection.dataProcessing.fourth.sectionThriteen.dashFive"
              )}
            ></ListItem>
          </ul>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFourteen.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFourteen.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFourteen.describtionTwo"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFiveteen.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFiveteen.describtionOne"
            )}
          </span>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionFiveteen.describtionTwo"
            )}
          </span>

          <Separator space="s"></Separator>

          <h4>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSixteen.title"
            )}
          </h4>
          <span>
            {t(
              "imprint.dataProtection.dataProcessing.fourth.sectionSixteen.describtion"
            )}
          </span>
        </div>

        {/* Legal infomations */}
        <div className={styles.contentWrapper}>
          <h2>{t("imprint.termsAndConditions.title")}</h2>
          <span>{t("imprint.termsAndConditions.describtion")}</span>
          <Separator space="xxs"></Separator>
          <PatternlibTextlink
            href={
              i18n.language === "de-DE" || i18n.language === "de"
                ? agbs
                : termsAndConditions
            }
            label={t("imprint.termsAndConditions.link")}
          ></PatternlibTextlink>
        </div>
      </div>
    </div>
  );
};

export default Imprint;
